import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "samplecomponent" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "Table", -1)
const _hoisted_3 = { class: "samplecomponent__article" }
const _hoisted_4 = { class: "samplecomponent__reactive" }
const _hoisted_5 = { class: "samplecomponent__component" }
const _hoisted_6 = { class: "samplecomponent__resizable" }
const _hoisted_7 = { class: "samplecomponent__options" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text--xs" }, "Props", -1)
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"samplecomponent__article\"><h2>Slots</h2><ul><li><span class=\"text--medium\">slot table.headers:</span><span> Allows to customize the header</span><pre class=\"code\">template(v-slot:table.headers)\n  h2 Title</pre></li><li><span class=\"text--medium\">slot table.headers.actions:</span><span> Allows to customize the filter</span><pre class=\"code\">template(v-slot:table.headers.actions)\n  input(type=&quot;search&quot; v-model=&quot;search&quot; @onchange=&quot;getItemsFromApi()&quot;)</pre></li><li><span class=\"text--medium\">slot table.header.{{id}}:</span><span> Allows to customize the column title</span><pre class=\"code\">template(v-slot:table.header.adress=&quot;{header}&quot;)\n  Icon(name=&quot;adress&quot;)\n  span {{ header.title }}</pre></li><li><span class=\"text--medium\">slot table.item.prepend.custom:</span><span> Allows to add an extra content as first cell</span><pre class=\"code\">template(v-slot:table.item.prepend.custom=&quot;{item}&quot;)\n  td.table__cell(data-label=&quot;selector&quot;)\n    input(type=&quot;checkbox&quot; :id=&quot;item.id&quot; name=&quot;selectedItems&quot;)</pre></li><li><span class=\"text--medium\">slot table.item.prepend:</span><span> Allows to add an extra content as first cell with default cell class</span><pre class=\"code\">template(v-slot:table.item.prepend=&quot;{item}&quot;)\n  input(type=&quot;checkbox&quot; :id=&quot;item.id&quot; name=&quot;selectedItems&quot;)</pre></li><li><span class=\"text--medium\">slot table.item.custom.{{id}}</span><span> Allows to customize the entire cell</span><pre class=\"code\">template(v-slot:table.item.name=&quot;{item, value, field, classes}&quot;)\n  td.table__cell.table__cell-red(:data-label=&quot;field&quot; :class=&quot;classes&quot;)\n    router-link.sample__menu-link(:to=&quot;{name: &#39;client&#39;, prams: {id: item.id}}&quot;) {{ value }}</pre></li><li><span class=\"text--medium\">slot table.item.{{id}}</span><span> Allows to customize the cell content</span><pre class=\"code\">template(v-slot:table.item.name=&quot;{item, value}&quot;)\n  router-link.sample__menu-link(:to=&quot;{name: &#39;client&#39;, prams: {id: item.id}}&quot;) {{ value }}</pre></li><li><span class=\"text--medium\">slot table.item.append.custom:</span><span> Allows to add an extra content as last cell</span><pre class=\"code\">template(v-slot:table.item.append.custom=&quot;{item}&quot;)\n  td.table__cell(data-label=&quot;selector&quot;)\n    Button(icon=&quot;check&quot; size=&quot;sm&quot; @clicked=&quot;action(item)&quot;)</pre></li><li><span class=\"text--medium\">slot table.item.append:</span><span> Allows to add an extra content as last cell with default cell class</span><pre class=\"code\">template(v-slot:table.item.append=&quot;{item}&quot;)\n  Button(icon=&quot;check&quot; size=&quot;sm&quot; @clicked=&quot;action(item)&quot;)</pre></li><li><span class=\"text--medium\">slot table.footer:</span><span> Allows to customize the footer</span><pre class=\"code\">template(v-slot:table.headers)\n  Paginator(:totalItems=&quot;filteredItems.length&quot; v-model:page=&quot;page&quot; v-model:itemsPage=&quot;itemsPage&quot; v-bind=&quot;translatePagination&quot;)</pre></li></ul></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Table = _resolveComponent("Table")
  const _component_InputText = _resolveComponent("InputText")
  const _component_InputCheckbox = _resolveComponent("InputCheckbox")
  const _component_InputSelect = _resolveComponent("InputSelect")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_Table, {
              headers: _ctx.props.sendHeaders ? _ctx.tableHeaders : undefined,
              items: _ctx.props.sendItems ? _ctx.tableItems : [],
              title: _ctx.props.title,
              loading: _ctx.props.loading,
              compact: _ctx.props.compact,
              emptyText: _ctx.props.emptyText,
              loadingText: _ctx.props.loadingText,
              filter: _ctx.props.filter,
              paginator: _ctx.props.paginator,
              size: _ctx.props.size
            }, {
              "table.item.surnames": _withCtx(({item}) => [
                _createVNode("span", null, _toDisplayString(item.surname1 + ' ' + item.surname2), 1)
              ]),
              "table.item.actions": _withCtx(({item}) => [
                _createVNode(_component_Button, {
                  icon: "check",
                  size: "sm",
                  onClicked: ($event: any) => (_ctx.action(item))
                }, null, 8, ["onClicked"])
              ]),
              _: 1
            }, 8, ["headers", "items", "title", "loading", "compact", "emptyText", "loadingText", "filter", "paginator", "size"])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode("p", null, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.props.title,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.props.title = $event)),
              label: "title"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.props.emptyText,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.props.emptyText = $event)),
              label: "emtyText"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputCheckbox, {
              modelValue: _ctx.props.compact,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.props.compact = $event)),
              label: "compact"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputCheckbox, {
              modelValue: _ctx.props.filter,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.props.filter = $event)),
              label: "filter"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputCheckbox, {
              modelValue: _ctx.props.paginator,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.props.paginator = $event)),
              label: "paginator"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.props.size,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.props.size = $event)),
              options: _ctx.sizes,
              label: "size"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputCheckbox, {
              modelValue: _ctx.props.sendHeaders,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.props.sendHeaders = $event)),
              label: "sendHeaders"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputCheckbox, {
              modelValue: _ctx.props.sendItems,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.props.sendItems = $event)),
              label: "sendItems"
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _hoisted_9
  ]))
}